import './index.css';
import ChartContent from './components/ChartContent/ChartContent';
import { PageDescription } from '@/shared/components';

function ChartPage() {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <PageDescription title={'Приложения'} />
      <ChartContent />
    </div>
  );
}
export default ChartPage;
